import type { PublicAuthLocale } from "@/components/public-auth/i18n/types"

/**
 * Append or replace `lng` on a path or absolute URL for auth/landing cross-links.
 */
export function appendLngParam(href: string, locale: PublicAuthLocale): string {
  if (!locale) return href

  try {
    const isAbsolute = href.startsWith("http://") || href.startsWith("https://")
    const base = isAbsolute ? undefined : "http://local"
    const url = new URL(href, base)
    url.searchParams.set("lng", locale)
    if (isAbsolute) return url.toString()
    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    const separator = href.includes("?") ? "&" : "?"
    if (href.includes("lng=")) {
      return href.replace(/([?&])lng=[^&]*/i, `$1lng=${locale}`)
    }
    return `${href}${separator}lng=${locale}`
  }
}
